import { FieldPath, FieldValues, useController } from 'react-hook-form';
import { UseFormComboboxProps } from 'components/form/UseFormCombobox';
import { useFormError } from 'components/form/UseFormError';
import {
    GooglePlacesCombobox,
    GooglePlacesComboboxProps,
} from 'components/google-places-combobox/GooglePlacesCombobox';

interface UseFormGooglePlacesComboboxProps<T extends FieldValues, K extends FieldPath<T>>
    extends UseFormComboboxProps<T, K>,
        Omit<GooglePlacesComboboxProps, 'name' | 'defaultValue'> {}

const UseFormGooglePlacesCombobox = <T extends FieldValues, K extends FieldPath<T>>(
    props: UseFormGooglePlacesComboboxProps<T, K>,
) => {
    const {
        name,
        rules,
        control,
        defaultValue,
        onChangeValue: onChangeValueConsumer,
        ...restInputProps
    } = props;

    const error = useFormError(name as FieldPath<T>);
    const {
        field: { onChange: onChangeInternal, ...restField },
    } = useController({
        name,
        control,
        defaultValue,
        rules,
    });

    return (
        <GooglePlacesCombobox
            isError={!!error}
            onChangeValue={value => {
                onChangeInternal(value);
                onChangeValueConsumer?.(value);
            }}
            {...restInputProps}
            {...restField}
        />
    );
};

export { UseFormGooglePlacesCombobox };
export type { UseFormGooglePlacesComboboxProps };
